<h2 class="sr-only">{{ "Standardsuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="gsNummer" #form="ngForm">
  <cap-grundstueck-nummer
    (ngModelChange)="gsNummer && (gsNummer.grundstueckNummer = $event)"
    [hasfocus]="true"
    [ngModel]="gsNummer && gsNummer.grundstueckNummer"
    [nurGueltige]="false"
    [searchMode]="gbGemeindeSearchMode"
    heading="GrundstueckNummer"
    name="grundstueckNummer"></cap-grundstueck-nummer>
  <div class="row mt-2">
    <div class="col-4">
      <cap-grundstuecktype-selection
        (ngModelChange)="gsNummer && (gsNummer.grundstueckTypAuswahl = $event)"
        [folioSucheMoeglich]="
          gsNummer && gsNummer.grundstueckTypAuswahl && !(gsNummer.grundstueckTypAuswahl.mSucheFolio.access === 'DEACTIVATED')
        "
        [ngModel]="gsNummer && gsNummer.grundstueckTypAuswahl"
        name="grundstuecktypeSelection"></cap-grundstuecktype-selection>
    </div>
    <div class="col-3">
      <cap-history-options
        (ngModelChange)="gsNummer && (gsNummer.historySearchOptions = $event)"
        [ngModel]="gsNummer && gsNummer.historySearchOptions"
        name="historySearchOptions"></cap-history-options>
    </div>
  </div>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
